__turbopack_context__.v({
  "author-link": "BlogCard-module__PrsQuW__author-link",
  "blog-card": "BlogCard-module__PrsQuW__blog-card",
  "category-link": "BlogCard-module__PrsQuW__category-link",
  "title": "BlogCard-module__PrsQuW__title",
});
